import React from 'react';

// styles
import styles from './FormError.module.less';

const FormError = ({ children }) => {
  if (!children) return null;

  return <label className={styles.formLabel}>{children}</label>
};

export default FormError;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/FormError.jsx